<template>
  <v-layout row justify-center align-center
            v-if="folder.entity"
  >
    <v-menu open-on-hover>
      <v-chip slot="activator" color="grey-lighten-2">
        <v-avatar size="8" color="white">
          <v-icon size="16" color="grey">mdi-briefcase</v-icon>
        </v-avatar>
        <span class="text-truncate transition-ease-in-out" :style="{'max-width': chipWidth}">{{ folder.entity.name }}</span>
      </v-chip>
      <v-card dark>
        <v-layout align-center justify-center>
          <v-layout justify-center align-center class="pa-3">
            <v-icon dark>mdi mdi-briefcase</v-icon>
          </v-layout>

          <v-layout align-start justify-center column class="pa-2">
            <span>{{ folder.entity.name }}</span>
            <v-layout align-center justify-center>
              <span>{{ folder.entity.cpf_cnpj.length === 11 ? 'CPF:' : 'CNPJ:' }}</span>
              <v-text-field
                solo
                hide-details
                v-model="folder.entity.cpf_cnpj"
                :mask="folder.entity.cpf_cnpj.length === 11 ? masks.cpf : masks.cnpj"
                disabled
                flat
              />
            </v-layout>
          </v-layout>
        </v-layout>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
  import masks from '@/mixins/masks';
  import { truncate } from 'lodash';

  export default {
    name: 'FolderEntity',
    props: ['maxWidth'],
    data() {
      return {
        masks,
        truncate,
      };
    },
    computed: {
      chipWidth() {
        return this.maxWidth ? `${Math.floor(this.maxWidth * .75)}px` : '35ch';
      },
      folder() {
        return this.$store.getters.activeFolder;
      },
    },
  };
</script>

<style>
.classText {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/entity/FolderEntity.vue